import { SVGProps } from 'react';

const Diameter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.48 3.66a10 10 0 0 1 13.86 13.86M6.41 6.41l11.18 11.18M3.66 6.48a10 10 0 0 0 13.86 13.86M21 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0M7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default Diameter;
